import { activityLogContract } from './activity-log/activity-log.contract';
import { aiPerformanceContract } from './ai-performance/ai-performance.contract';
import { articleArchitectContract } from './article-architect/article-architect.contract';
import { botContract } from './bot/bot.contract';
import { cannedResponseContract } from './canned-responses/canned-response.contract';
import { chatContract } from './chat/chat.contract';
import { companyContract } from './company/company.contract';
import { contactLookupContract } from './contact-lookup/contact-lookup.contract';
import { conversationKeywordsContract } from './conversation-keywords/conversation-keywords.contract';
import { dashboardContract } from './dashboard/dashboard.contract';
import { dataSourcesContract } from './data-sources/data-sources.contract';
import { DataSourceFoldersContract } from './data-sources-folders/data-sources-folders.contract';
import { DataSourceSubfoldersContract } from './data-sources-folders/data-sources-subfolders.contract';
import { emailReplyContract } from './email-reply/email-reply.contract';
import { emailTemplateContract } from './email-template/email-template.contract';
import { experimentResultContract } from './experiment-result/experiment-result.contract';
import { flowContract } from './flow/flow.contract';
import { gdprContract } from './gdpr/gdpr.contract';
import { handoverContract } from './handover/handover.contract';
import { homeContract } from './home/home.contract';
import { inboxContract } from './inbox/inbox.contract';
import { labelContract } from './label/label.contract';
import { llmUsagesContract } from './llm-usages/llm-usages.contract';
import { notificationsContract } from './notifications/notifications.contract';
import { platformSettingsContract } from './platform-settings/platform-settings.contract';
import { previewContract } from './preview/preview.contract';
import { publicApiSettingsContract } from './public-api/public-api.contract';
import { reportingContract } from './reporting/reporting.contract';
import { revisionsContract } from './revisions/revisions.contract';
import { rompslompContract } from './rompslomp/rompslomp.contract';
import { sharepointContract } from './sharepoint/sharepoint.contract';
import { statusContract } from './status/status.contract';
import { subflowTemplatesContract } from './subflow-templates/subflow-templates.contract';
import { suggestionBoxContract } from './suggestion-box/suggestion-box.contract';
import { templateResponseContract } from './template-response/template-response.contract';
import { testAccuracyContract } from './test-accuracy/test-accuracy.contract';
import { ticketDeflectionContract } from './ticket-deflection/ticket-deflection.contract';
import { topdeskContract } from './topdesk/topdesk.contract';
import { trainAIContract } from './train-ai/train-ai.contract';
import { LLMContract } from './vector/llm/llm.contract';
import { voiceAIContract } from './voice-ai/voice-ai.contract';
import { webScraperContract } from './web/web-scraper.contract';
import { webclientAccessContract } from './webclient-access/webclient-access.contract';
import { weeklyBriefContract } from './weekly-brief/weekly-brief.contract';
import { zendeskContract } from './zendesk/zendesk.contract';

export type {
  TActivityLogActionDTO,
  TActivityLogResourceDTO,
} from './activity-log/activity-log.dto';
export type {
  TCannedResponseDataDTO,
  TCannedResponseDTO,
} from './canned-responses/canned-response.dto';
export type { HandoverDTO } from './handover/handover.dto';
export type { InboxDTO } from './inbox/inbox.dto';
export type {
  RevisionCreateDTO,
  RevisionDTO,
  RevisionUpdateDTO,
} from './revisions/revisions.dto';

export type {
  TLLMQuerySchema,
  TLLMResponseSchema,
} from './vector/llm/llm.contract';

export const contracts = {
  articleArchitect: articleArchitectContract,
  conversationKeywords: conversationKeywordsContract,
  inbox: inboxContract,
  handover: handoverContract,
  flow: flowContract,
  activityLog: activityLogContract,
  cannedResponses: cannedResponseContract,
  status: statusContract,
  gdpr: gdprContract,
  label: labelContract,
  bot: botContract,
  chat: chatContract,
  revisions: revisionsContract,
  reporting: reportingContract,
  company: companyContract,
  dataSource: dataSourcesContract,
  dataSourceFolders: DataSourceFoldersContract,
  dataSourceSubfolders: DataSourceSubfoldersContract,
  webclientAccess: webclientAccessContract,
  subflowTemplates: subflowTemplatesContract,
  preview: previewContract,
  llmUsages: llmUsagesContract,
  topdesk: topdeskContract,
  zendesk: zendeskContract,
  dashboard: dashboardContract,
  platformSettings: platformSettingsContract,
  suggestionBox: suggestionBoxContract,
  webScraper: webScraperContract,
  testAccuracy: testAccuracyContract,
  emailReply: emailReplyContract,
  emailTemplate: emailTemplateContract,
  publicApi: publicApiSettingsContract,
  templateResponse: templateResponseContract,
  home: homeContract,
  notifications: notificationsContract,
  voiceAI: voiceAIContract,
  ticketDeflection: ticketDeflectionContract,
  sharepoint: sharepointContract,
  rompslomp: rompslompContract,
  experimentResult: experimentResultContract,
  aiPerformance: aiPerformanceContract,
  trainAI: trainAIContract,
  contactLookup: contactLookupContract,
  weeklyBrief: weeklyBriefContract,
};

// TODO: Figure out how to structure this better
// NOTE: Contracts relating to @conversed/vector
export const Contracts = {
  vector: {
    status: statusContract,
    llm: LLMContract,
  },
};
